import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../constants/errorMessage'
import './qrScanCss.scss'
import CommonQr from '../../global/ScanQrCode/CommonQr'

// PROMOCODE SCANNING QR
function ScanQr(props) {
    const { notify, setIsScanDisplay, setScanResult, scanResult, clasName } = props
    const [isDataRecorded, setIsDataRecorded] = useState(false)

    useEffect(() => {
        if (scanResult && scanResult != null) {
            //    Action for Scann

        }
    }, [scanResult])

    const handleScan = (data) => {

        if (data?.text) {
            if (!isDataRecorded) {
                //Redirect
                // const facilityData = data?.text.split('https://demo-transient.parkengage.com/')
                // navigate(`/${facilityData[1]}`)
                setScanResult(data?.text)
                setIsScanDisplay(false)
                setIsDataRecorded(true)
            }
            setIsDataRecorded(true)
        } else {
            setIsDataRecorded(false)
        }
    }
    const doNothing = () => { }
    const handleError = () => {
        notify(errorMessage?.somethingWentWrong)
        setIsDataRecorded(true)
    }

    const sendBack = () => {
        setIsScanDisplay(false)
    }
    return (
        <div className={clasName ? clasName : 'zIndexHigh top-0 position-fixed bg-white h-100'}>
            <CommonQr
                isDisplayBack={true}
                handleClose={() => sendBack()}
                isParentCss={false}
                onError={handleError}
                onScan={!isDataRecorded ? handleScan : doNothing}
            />
        </div>
    )
}

ScanQr.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    scanResult: PropTypes.string,
    setScanResult: PropTypes.func,
    notify: PropTypes.func,
    setIsScanDisplay: PropTypes.func,
    clasName: PropTypes.string,
}

ScanQr.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    scanResult: '',
    setScanResult: noop,
    notify: noop,
    setIsScanDisplay: noop,
    clasName: '',
}

function mapStateToProps({ gatedCheckinReducer }) {
    return {
        loader: gatedCheckinReducer?.loader,
        isFetching: gatedCheckinReducer?.isFetching
    }
}
export default connect(mapStateToProps)(ScanQr)
